export default __webpack_public_path__ + "static/gs-2-target--mobile-0e27c2c16cc73b1a6024de09f52b782d.webp";